// extracted by mini-css-extract-plugin
export default {"wrapper":"ageTargetBox_wrapper__XQ3tI","buttonWrapper":"ageTargetBox_buttonWrapper__zgWKS","inputWrapper":"ageTargetBox_inputWrapper__+yvy7"};